(function ($, Cobalt, undefined) {
    var setupThreadPrefixSort = function () {
        if (location.search.indexOf("filter") < 0) {

            $(".forum-thread-prefix-listing").tableDnD({
                onDragClass: "dragHandle",
                dragHandle: "col-icon-drag-handle",
                onDrop: function (table, rowDropped) {

                },
                onDragStart: function (table, row) {

                },
                onAllowDrop: function (draggedRow, dropRow) {
                    return true;
                }
            });

            $("#sort-prefix-display-order-form").submit(function (e) {
                var SortedParagonIDs = new Array();

                $(".forum-thread-prefix-listing > tbody > tr > td:first-child").each(function (index, contest) {
                    SortedParagonIDs.push(contest.firstChild.getAttribute("data-id"));
                });

                $("#field-prefix-order").val(SortedParagonIDs);
            });
        }
        else {
            //hide the first to sorting columns if the list has been sorted
            $(".forum-thread-prefix-listing").find("thead>tr>th").first().hide();

            $(".forum-thread-prefix-listing").find("tbody>tr").each(function () {
                var row = $(this);
                row.find("td").first().hide();
            });

            $(".update-prefix-order").hide();
        }

    }

    Cobalt.CPForumThreadPrefix = {
        initialize: function () {
            setupThreadPrefixSort();
        }
    }
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.CPForumThreadPrefix.js